import { cn } from 'components/UI/cn'
import { PiX } from 'react-icons/pi'

export function FilterCloseButton(props: {
  isActive: boolean
  /** Hide the X while the popover is open — the trigger shows its own caret
   *  in that state and the X would visually collide with it. */
  open?: boolean
  onClick?: React.MouseEventHandler<HTMLButtonElement>
}) {
  const visible = props.isActive && !props.open
  return (
    <div className="absolute top-0 bottom-0 right-2 flex items-center justify-center pointer-events-none">
      <button
        type={'button'}
        aria-label="Clear filter"
        className={cn(
          'pointer-events-auto flex items-center justify-center cursor-pointer',
          'bg-transparent border-none p-0.5 rounded-full text-brand-active',
          'hover:bg-basil-100 transition-colors',
          {
            hidden: !visible,
          }
        )}
        onClick={(e) => {
          e.stopPropagation()
          props.onClick?.(e)
        }}
      >
        <PiX size={14} />
      </button>
    </div>
  )
}
